export const fieldOrder = [
  'minusorb',
  'minushp',
  'black',
  'white'
];

class D12Game {
  constructor(board, hp) {
    this.hp = hp;
    this.board = board;
    this.x = 0;
    this.y = 0;
    this.energy = 0;
    this.turns = [];
  }

  getPossibleMoves()
  {
    if (this.hp <= 0) {
      return ["DEAD"];
    }
    if (this.energy >= 10 && this.standingOn === "white") {
      return ["ATTACK"];
    }


    let moves = [];


    if (this.x <= 0) {
      moves.push("right");
    }
    if (this.x >= 0) {
      moves.push("left");
    }
    if (this.y <= 0) {
      moves.push("down");
    }
    if (this.y >= 0) {
      moves.push("up");
    }

    let movePriority = {};
    moves.forEach(moveDirection => {
      let wouldMoveTo;
      switch (moveDirection) {
        case 'up':
          wouldMoveTo = this.board[(this.y) * 3 + (this.x + 1)];
          break;
        case 'down':
          wouldMoveTo = this.board[(this.y + 2) * 3 + (this.x + 1)];
          break;
        case 'right':
          wouldMoveTo = this.board[(this.y + 1) * 3 + (this.x + 2)];
          break;
        case 'left':
          wouldMoveTo = this.board[(this.y + 1) * 3 + (this.x)];
          break;
      }
      if (wouldMoveTo === 'white' && this.energy >= 10) {
        movePriority[moveDirection] = -9999;
        return;
      }
      let prio = 0;
      switch (wouldMoveTo) {
        case 'black':
          prio = -100;
          break;
        case 'white':
          prio = -70;
          break;
      }
      movePriority[moveDirection] = prio;
      // TODO: Add preferation for center position?
    });

    moves = moves.sort((a, b) => {
      return movePriority[a] - movePriority[b];
    });

    if (movePriority[moves[0]] === -9999) {
      return [moves[0]]; // Only return [winningMoveDirection] here. No point going to / checking other directions and their possible subtrees after winning here
    }

    return moves;
  }

  getBoardIndex()
  {
    let col = this.x + 1;
    let row = this.y + 1;
    return row * 3 + col;
  }

  postMove()
  {
    if (this.x < -1 || this.x > 1 || this.y < -1 || this.y > 1) {
      throw Error("Invalid move");
    }
    this.standingOn = this.board[this.getBoardIndex()];
    this.hp -= 30; // Dragon hit
    switch (this.standingOn) {
      case 'minusorb':
        this.energy = Math.max(0, this.energy - 5);
        this.hp += 5;
        break;
      case 'minushp':
        this.hp -= 500;
        break;
      case 'black':
        this.energy++;
        this.hp -= 25;
        break;
      case 'white':
        // Nothing
        break;
      default:
        throw Error("Board config / Standing on wrong");
    }

    this.rotateBoard();
  }

  rotateBoard()
  {
    let newBoard = [];
    let standing = this.getBoardIndex();
    for (let i = 0; i < 9; i++) {
      if (i === standing) {
        newBoard[i] = this.standingOn;
      } else {
        newBoard[i] = fieldOrder[(fieldOrder.indexOf(this.board[i]) + 1) % fieldOrder.length];
      }
    }
    this.board = newBoard;
  }

  printBoard(printfn)
  {
    printfn(`<pre>${this.getBoardPosForPrint(0)} ${this.getBoardPosForPrint(1)} ${this.getBoardPosForPrint(2)}\n${this.getBoardPosForPrint(3)} ${this.getBoardPosForPrint(4)} ${this.getBoardPosForPrint(5)}\n${this.getBoardPosForPrint(6)} ${this.getBoardPosForPrint(7)} ${this.getBoardPosForPrint(8)}</pre>`)
  }

  getBoardPosForPrint(i)
  {
    let val = this.board[i];
    if (this.getBoardIndex() === i) {
      return val.toUpperCase();
    }
    return val;
  }

  move(direction, printfn = null)
  {
    switch (direction) {
      case 'up':
        this.y--;
        break;
      case 'down':
        this.y++;
        break;
      case 'right':
        this.x++;
        break;
      case 'left':
        this.x--;
        break;
    }

    this.postMove();

    this.turns.push(direction);

    if (printfn) {
      printfn(`Move ${direction} to ${this.x}/${this.y} (${this.standingOn}). ${this.hp} HP, ${this.energy} Energy`)
      this.printBoard(printfn);
    }

  }

  getClone()
  {
    let game = new D12Game(this.board, this.hp);
    game.x = this.x;
    game.y = this.y;
    game.energy = this.energy;
    game.standingOn = this.standingOn;
    game.turns = [...this.turns];
    return game;
  }

  replay(gameWithTurns, printfn)
  {
    printfn(`Start with ${this.hp} HP, ${this.energy} Energy`);
    this.printBoard(printfn);
    gameWithTurns.turns.forEach(moveDirection => {
      printfn('<hr/>');
      this.move(moveDirection, printfn);
    });
  }
}

export default D12Game
